import { render } from "./Calculation.vue?vue&type=template&id=f450f9f8&scoped=true"
import script from "./Calculation.vue?vue&type=script&lang=js"
export * from "./Calculation.vue?vue&type=script&lang=js"

import "./Calculation.vue?vue&type=style&index=0&id=f450f9f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f450f9f8"]])

export default __exports__